import { BUTTON_TYPES, INSERT_PLUGIN_BUTTONS, TOOLBARS } from 'wix-rich-content-editor-common';
import { DEFAULTS } from '../defaults.js';
import InsertPluginIcon from '../icons/InsertPluginIcon.js';
import 'react';

const createInsertButtons = ({
  settings,
  t
}) => {
  var _a, _b;
  const icon = ((_b = (_a = settings == null ? void 0 : settings.toolbar) == null ? void 0 : _a.icons) == null ? void 0 : _b.InsertPluginButtonIcon) || InsertPluginIcon;
  const fileInsertButton = {
    type: BUTTON_TYPES.FILE,
    multi: true,
    name: INSERT_PLUGIN_BUTTONS.FILE,
    tooltip: t("FileUploadInsertButton_tooltip"),
    getIcon: () => icon,
    componentData: DEFAULTS,
    toolbars: [TOOLBARS.INSERT_PLUGIN, TOOLBARS.MOBILE, TOOLBARS.FOOTER, TOOLBARS.SIDE]
  };
  return [fileInsertButton];
};

export { createInsertButtons as default };
//# sourceMappingURL=insert-buttons.js.map
